import React from 'react'

import { CallMeBack } from 'omnicom/components/layout/callMeBack/CallMeBack'
import { UnsubscribeMe } from 'omnicom/components/layout/unsubscribeMe/UnsubscribeMe'
import Survey from 'omnicom/components/widgets/Survey/Survey'
import LayoutLogin from 'src/core/layout/Login'
import { IRouteData } from 'src/core/routes/types'

export const CustomRoutes: IRouteData[] = [
  {
    path: '/',
    element: <LayoutLogin />,
    access: 'Guest',
  },
  {
    path: '/page/Survey/*',
    element: <Survey />,
    access: 'Common',
    wrappedInLayout: true,
  },
  {
    path: '/page/call-me-back/*',
    element: <CallMeBack />,
    access: 'Common',
  },
  {
    path: '/page/unsubscribe/*',
    element: <UnsubscribeMe />,
    access: 'Common',
  },
]
